/**
 * @file: description
 * @author: dongjing
 * @Date: 2020-02-24 09:37:47
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-03-03 15:03:07
 */
import { CM, Tction } from '@tkit/model';
import { TkitUtils as Utils } from '@tkit/types';
import {
  APIS,
  ShoppingInfo,
  PageableResultShoppingInfo,
  ParamsshopShoplistUsingGet,
  CoinRecordVO,
  ParamsshopCoinRecordUsernameUsingGet,
  ParamsshopOrderInfoUsingGet,
  ParamsshopCancelOrderOrderIdUsingPut,
  ParamsshopConvertedProductIdUsingPost,
  ParamsshopShopinfoProductIdUsingGet,
  PageableResultOrderInfoVO
} from '@src/services';
import { message as Message } from 'antd';
import lodash from 'lodash';
import moment from 'moment';

export interface BalanceMap {
  title: string;
  data: CoinRecordVO[];
}
export interface State {
  /** 加载状态 */
  loading: boolean;
  /** 个人账户信息 */
  userShopInfo: ShoppingInfo;
  /** 商品列表 */
  shopListModel: PageableResultShoppingInfo;
  /** 账户明细 */
  userBalance: CoinRecordVO[];
  /** 历史记录 */
  historyRecordModel: PageableResultOrderInfoVO;
  /** 商品信息 */
  shopInfo: ShoppingInfo;
  userBalanceMap: BalanceMap[];
}

export const mallModelState: State = {
  loading: false,
  userShopInfo: {},
  shopListModel: {},
  userBalance: [],
  historyRecordModel: {},
  shopInfo: {},
  userBalanceMap: []
};

const model = CM({
  state: mallModelState,
  namespace: 'mallModel',
  reducers: {
    reset: (state: any) => {
      return {
        ...state,
        historyRecordModel: {},
        shopInfo: {},
        userBalanceMap: []
      };
    },
    // 更新loading状态
    updateLoading: (state, action: Tction<{ loading: boolean }>) => {
      const { loading } = action.payload;
      return {
        ...state,
        loading
      };
    },
    /** 个人信息 */
    setUserShopInfo: (state, action: Tction<{ userShopInfo: ShoppingInfo }>) => {
      const { userShopInfo } = action.payload;
      return {
        ...state,
        userShopInfo
      };
    },
    /** 更新正在兑换数量 */
    updateUserShopInfoOrder: state => {
      const { orderBookingNum } = state.userShopInfo;
      return {
        ...state,
        userShopInfo: {
          ...state.userShopInfo,
          orderBookingNum: orderBookingNum && orderBookingNum - 1
        }
      };
    },
    /** 更新账户余额 */
    updateUserShopInfo: (state, action: Tction<{ payNum: number }>) => {
      const { payNum } = action.payload;
      const {
        userShopInfo: { kcoin },
        shopInfo: { productPrices }
      } = state;
      return {
        ...state,
        userShopInfo: {
          ...state.userShopInfo,
          kcoin: kcoin && productPrices && kcoin - payNum * productPrices
        }
      };
    },
    /** 商品列表 */
    setShopListModel: (state, action: Tction<{ shopListModel: PageableResultShoppingInfo }>) => {
      const { shopListModel } = action.payload;
      return {
        ...state,
        shopListModel
      };
    },
    /** 账户明细 */
    setUserBalance: (state, action: Tction<{ userBalance: CoinRecordVO[] }>) => {
      const { userBalance } = action.payload;
      return {
        ...state,
        userBalance
      };
    },
    /** 根据月份进行明细分组 */
    updateUserBalance: (state, action: Tction<{ userBalance: CoinRecordVO[] }>) => {
      const { userBalance } = action.payload;
      const newArr: BalanceMap[] = [];
      const obj = lodash.groupBy<CoinRecordVO>(userBalance, function(item) {
        return moment(item.lastUpdateTime ? item.lastUpdateTime : item.createTime).format(
          'YYYY-MM'
        );
      });
      for (const key in obj) {
        newArr.push({ title: key, data: JSON.parse(JSON.stringify(obj[key])) });
      }
      return {
        ...state,
        userBalanceMap: JSON.parse(JSON.stringify(newArr))
      };
    },

    /** 历史记录,正在兑换 */
    setHistoryRecord: (
      state,
      action: Tction<{ historyRecordModel: PageableResultOrderInfoVO }>
    ) => {
      const { historyRecordModel } = action.payload;
      return {
        ...state,
        historyRecordModel
      };
    },
    /** 商品详情 */
    setShopInfo: (state, action: Tction<{ shopInfo: ShoppingInfo }>) => {
      const { shopInfo } = action.payload;
      return {
        ...state,
        shopInfo
      };
    },
    /** 更新商品详情 */
    updateShopInfo: (state, action: Tction<{ payNum: number }>) => {
      const { payNum } = action.payload;
      return {
        ...state,
        shopInfo: {
          ...state.shopInfo,
          repertory: state.shopInfo.repertory && state.shopInfo.repertory - payNum
        }
      };
    },
    /** 更新商品库存 */
    updateShopListNum: (
      state,
      action: Tction<{ productId: string; payNum: number; add: number }>
    ) => {
      const { payNum, productId, add } = action.payload;
      const { list } = state.shopListModel;
      return {
        ...state,
        shopListModel: {
          ...state.shopListModel,
          list:
            list &&
            list.map(item => {
              if (item.productId === productId) {
                return {
                  ...item,
                  repertory: item.repertory && item.repertory + payNum * add
                };
              }
              return item;
            })
        }
      };
    }
  },
  effects: {
    /**
     * @description 个人账户信息
     */
    *getUserShopInfo({ tCall, tPut }): Iterator<{}, any, any> {
      // yield tPut(model.actions.changeLoading, { loading: action.payload.loading });
      const res: Utils.GetROA<typeof APIS.ShopApi.shopPersonalAccountUsingGet> = yield tCall(
        APIS.ShopApi.shopPersonalAccountUsingGet
      );
      const { code, message, result } = res;
      if (code === 0) {
        yield tPut(model.actions.setUserShopInfo, { userShopInfo: result || {} });
      } else {
        Message.error(message);
      }
    },
    /**
     * @description 商品列表
     * @param param
     */
    *getShopListModel(
      { tCall, tPut },
      action: Tction<{
        params: ParamsshopShoplistUsingGet;
      }>
    ): Iterator<{}, any, any> {
      yield tPut(model.actions.updateLoading, { loading: true });
      const { params } = action.payload;
      const res: Utils.GetROA<typeof APIS.ShopApi.shopShoplistUsingGet> = yield tCall(
        APIS.ShopApi.shopShoplistUsingGet,
        params
      );
      const { code, message, result } = res;
      if (code === 0) {
        yield tPut(model.actions.setShopListModel, { shopListModel: result || {} });
      } else {
        Message.error(message);
      }
      yield tPut(model.actions.updateLoading, { loading: false });
    },
    /**
     * @description 账户明细
     */
    *getUserBalance(
      { tCall, tPut },
      action: Tction<{
        params: ParamsshopCoinRecordUsernameUsingGet;
      }>
    ): Iterator<{}, any, any> {
      const { params } = action.payload;
      const res: Utils.GetROA<typeof APIS.ShopApi.shopCoinRecordUsernameUsingGet> = yield tCall(
        APIS.ShopApi.shopCoinRecordUsernameUsingGet,
        params
      );
      const { code, message, result } = res;
      if (code === 0) {
        // yield tPut(model.actions.setUserBalance, { userBalance: result || [] });
        yield tPut(model.actions.updateUserBalance, { userBalance: result || [] });
      } else {
        Message.error(message);
      }
    },
    /**
     * @description 获取历史记录
     */
    *getHistoryRecord(
      { tCall, tPut },
      action: Tction<{
        params: ParamsshopOrderInfoUsingGet;
      }>
    ): Iterator<{}, any, any> {
      const { params } = action.payload;
      const res: Utils.GetROA<typeof APIS.ShopApi.shopOrderInfoUsingGet> = yield tCall(
        APIS.ShopApi.shopOrderInfoUsingGet,
        params
      );
      const { code, message, result } = res;
      if (code === 0) {
        yield tPut(model.actions.setHistoryRecord, { historyRecordModel: result || {} });
      } else {
        Message.error(message);
      }
    },
    /**
     * @description 取消交易
     */
    *cancleRemeed(
      { tPut, tCall },
      action: Tction<{
        params: ParamsshopCancelOrderOrderIdUsingPut;

        callBack?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callBack } = action.payload;
      const res: Utils.GetROA<typeof APIS.ShopApi.shopCancelOrderOrderIdUsingPut> = yield tCall(
        APIS.ShopApi.shopCancelOrderOrderIdUsingPut,
        params
      );
      const { code, message } = res;
      if (code === 0) {
        callBack && callBack();
        yield tPut(model.actions.updateUserShopInfoOrder);
        Message.success('已成功取消交易');
      } else {
        Message.error(message);
      }
    },
    /**
     * @description 获取商品详情
     */
    *getShopInfo(
      { tPut, tCall },
      action: Tction<{
        params: ParamsshopShopinfoProductIdUsingGet;
        callBack?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callBack } = action.payload;
      const res: Utils.GetROA<typeof APIS.ShopApi.shopShopinfoProductIdUsingGet> = yield tCall(
        APIS.ShopApi.shopShopinfoProductIdUsingGet,
        params
      );
      const { code, message, result } = res;
      if (code === 0) {
        yield tPut(model.actions.setShopInfo, { shopInfo: result || {} });
      } else {
        Message.error(message);
      }
    },
    /**
     * @description 购买商品
     */
    *buyShop(
      { tPut, tCall },
      action: Tction<{
        params: ParamsshopConvertedProductIdUsingPost;
        callBack?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callBack } = action.payload;
      const { payNum, productId } = params;
      const res: Utils.GetROA<typeof APIS.ShopApi.shopConvertedProductIdUsingPost> = yield tCall(
        APIS.ShopApi.shopConvertedProductIdUsingPost,
        params
      );
      const { code, message } = res;
      if (code === 0) {
        yield tPut(model.actions.updateUserShopInfo, {
          payNum
        });
        yield tPut(model.actions.updateShopInfo, { payNum });
        yield tPut(model.actions.getUserShopInfo);
        yield tPut(model.actions.updateShopListNum, { productId, payNum, add: -1 });

        callBack && callBack();
      } else {
        Message.error(message);
      }
    }
  }
});

/**
 * @description 全局Model mallModel 挂载到 redux 上
 */
export default model;
